<template>
    <iframe src="/swagger-ui.html" width="100%" height="100%"/>
</template>

<script>
	export default {
		name: "DocumentationView"
	}
</script>

<style scoped>

</style>
